import { render, staticRenderFns } from "./HorizontalCartBoxItem.vue?vue&type=template&id=3c218654&"
import script from "./HorizontalCartBoxItem.vue?vue&type=script&lang=js&"
export * from "./HorizontalCartBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports